// extracted by mini-css-extract-plugin
module.exports = {"root":"EllipseOutline_root__Vocia"};